import React from "react";
import { Route, Routes } from "react-router";
import { useAuthorization } from "@common/providers";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import Show from "./Show/Show";
import New from "./New/New";
import Edit from "./Edit/Edit";

const BlueprintsV2Mspa = (): JSX.Element => {
  const authorized = useAuthorization();
  if (!authorized) return <ScopeStackSpinner />;

  return (
    <div className="blueprintsV2Mspa">
      <Routes>
        <Route path="/" element={<Show />} />
        <Route path="/new" element={<New />} />
        <Route path="/:id/edit" element={<Edit />} />
      </Routes>
    </div>
  );
};

export default BlueprintsV2Mspa;
